module.exports = __webpack_public_path__ + "assets/img/modify.1758af56.svg";